export default __webpack_public_path__ + "static/contact-21f83b24af6ccf076aa862bd50a4d8d0.jpg";